import { DA_NavigationPage } from "../../../../../interfaces/navigationPage.interface";
import { checkCurrentOrAncestorPath } from "../../NavigationMobile/helpers/checkCurrentOrAncestorPath.helper";

export const recursiveCheckCurrentPathDesktop = (
    previous: DA_NavigationPage[],
    current: DA_NavigationPage
) => {
    const isInCurrentPath = checkCurrentOrAncestorPath(current.path);

    if (isInCurrentPath === true && current.path !== "/") {
        previous.push(current);

        if (current.children?.[0]) {
            return current.children.reduce(recursiveCheckCurrentPathDesktop, previous);
        }
    }

    return previous;
};
